import React, { Component } from 'react';
import loading from '../../Images/loading2_invert_colours.gif';
import Top_Bar from '../Part_Sample/Top_Bar';

export default class MSM_Transition_Screen extends Component {
	constructor(props) {
		super(props);
		window.app.hideLoading();

		this.state = {

		}

		this.is_back_button_pressed = false;
		this.has_reply_from_controller = false;
	}

	handlePrevious = () => {
		this.is_back_button_pressed = true;
		if (!this.has_reply_from_controller) {
			window.app.setMSMMode(true);
			this.props.receiver.active_controller.setActiveSite('');
			// Replace available functions with original
			this.props.receiver.active_controller.available_functions = { ...this.props.receiver.active_controller.msm_avaliable_functions }
			this.props.receiver.next_component = 'MSM';
			this.props.receiver.getMSMSiteList();
		}
	}

	componentDidMount() {
		if (this.props.param.is_msm_mode) {
			window.app.setMSMMode(true);
			this.props.receiver.active_controller.setActiveSite('');
			// Replace available functions with original
			this.props.receiver.active_controller.available_functions = { ...this.props.receiver.active_controller.msm_avaliable_functions }
			this.props.receiver.next_component = 'MSM';
			this.props.receiver.getMSMSiteList();
		} else {
			window.app.setMSMMode(false);
			this.props.receiver.active_controller.setActiveSite(this.props.param.site_id);
			this.props.receiver.readJSONFile({ name: 'functions.json' });
		}
	}

	rcvReadJSONFile = (response) => {
		if (!this.is_back_button_pressed) {
			this.props.receiver.stored_params.available_functions = response.data;
			this.props.receiver.next_component = 'Dashboard';
			this.props.receiver.getGroups();
		}
	}

	rcvPointList = (stored_params) => {
		if (!this.is_back_button_pressed) {
			this.has_reply_from_controller = true;
			this.props.receiver.active_controller.available_functions = stored_params.available_functions;
			delete stored_params.available_functions;
			this.props.receiver.next_component = '';
			window.app.onLogin(true, stored_params);
			this.props.receiver.stored_params = {};
		}
	}

	connectFailed = () => {

	}

	render() {
		let style = {
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height - 55,
			overflow: 'auto'
		}

		let loading_width = this.props.width * 0.2;
		if (loading_width > 100) loading_width = 100;
		let loading_left = (this.props.width - loading_width) / 2;

		let loading_style = {
			position: 'absolute',
			top: (this.props.height - 70) / 2,
			textAlign: 'center',
			width: '100%',
			verticalAlign: 'middle',
		}

		return (
			<div style={style} className='flipInY'>
				<Top_Bar
					width={this.props.width}
					title={this.props.receiver.getString('msm')}
					left_button_type={!this.props.param.is_msm_mode ? 'back' : ''}
					handleLeftButton={this.handlePrevious}
				/>
				<div style={loading_style}>
					<div>
						<img src={loading} style={{ width: loading_width, }} alt="Loading gif" />
					</div>
					<div>
						<span>{this.props.receiver.getString('connecting')}</span>
					</div>
				</div>
			</div>
		)
	}
}